module.exports = __webpack_public_path__ + "img/img-6.0ccba2f9.png";